import { Row, Col, Container, Spinner, Button, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { useEffect, useState, useCallback } from "react";

export const Announcement = () => {
  const { user: authUser } = useSelector((x) => x.auth);
  const [isLoading, setIsLoading] = useState(true);
  const [latestAnnouncement, setLatestAnnouncement] = useState(null);
  const [sectionDisplay, setSectionDisplay] = useState("none"); // State to control section display
  const [showModal, setShowModal] = useState(false)
  const url = process.env.REACT_APP_URL;

  const handleCloseModal = () => setShowModal(false)
  const handleShowModal = () => setShowModal(true)

  const getAnnouncements = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${url}/announcements`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      // Sort announcements by creation date (assuming `createdAt` field exists)
      const sortedAnnouncements = data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      // Get the latest announcement
      const latest = sortedAnnouncements[0] || null;

      // Check if the latest announcement is visible to the current user
      if (latest) {
        const isVisible = (() => {
          if (latest.to === "Public") {
            return true; // Always visible for Public
          }
          if (!authUser) {
            return false; // Hide if no authUser for non-Public announcements
          }
          switch (latest.to) {
            case "Officer":
              return authUser.user.acl === "Officer";
            case "Member":
              return ["Officer", "Member"].includes(authUser.user.acl);
            case "Guest":
              return ["Officer", "Member", "Guest"].includes(authUser.user.acl);
            default:
              return false;
          }
        })();

        // Set the display style based on visibility
        if (isVisible) {
          setLatestAnnouncement(latest);
          if (
            (latest.to === "Guest" && !authUser) ||
            (latest.to === "Member" && (!authUser || authUser.user.acl === "Guest")) ||
            (latest.to === "Officer" && (!authUser || authUser.user.acl !== "Officer"))
          ) {
            setSectionDisplay("none"); // Hide the section
          } else {
            setSectionDisplay("block"); // Show the section
          }
        } else {
          setLatestAnnouncement(null);
          setSectionDisplay("none"); // Hide the section
        }
      } else {
        setLatestAnnouncement(null);
        setSectionDisplay("none"); // Hide the section
      }
    } catch (e) {
      console.error(`Error fetching announcements: ${e}`);
    }
    setIsLoading(false);
  }, [authUser, url]);

  useEffect(() => {
    getAnnouncements();
  }, [getAnnouncements]);

  if (isLoading) {
    return <Spinner animation="border" variant="danger" />;
  }

  return (
    <section className="announcement" style={{ display: sectionDisplay }} id="announcement">
      <Container className="text-center announcement-container">
        <Row className='mt-3'>
          <Col className='mt-5'>
            {latestAnnouncement?.title && <h2 className='mt-4'>{latestAnnouncement.title}</h2>}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col className='mt-3 mb-3'>
            {latestAnnouncement?.description && (
              <div
                dangerouslySetInnerHTML={{ __html: latestAnnouncement.shortDescription }}
                className='announcement-description'
              ></div>
            )}
          </Col>
        </Row>
        {latestAnnouncement && (
          <Row className='mb-5'>
            <Col className='mb-5'>
              <Button onClick={handleShowModal}>Read More</Button>
              <Modal show={showModal} onHide={handleCloseModal} data-bs-theme={'dark'} size="lg" style={{ top: '2%' }}>
                <Modal.Header closeButton >
                  <Modal.Title>{latestAnnouncement.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col className='announcement-modal'>
                      <div dangerouslySetInnerHTML={{ __html: latestAnnouncement.description }}></div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};